// Small display helpers of the site diary pages.

export const LIST = "/user/site-diary";

export const dayUrl = (project, date) => `${LIST}/${project}/${date}`;

export const todayBerlin = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Berlin" }).format(new Date());

/** Minutes → "8,50" style hours in the user's locale. */
export const formatHours = minutes =>
  (Math.round((Number(minutes || 0) * 100) / 60) / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

/** "YYYY-MM-DD" ± days. */
export const shiftDay = (day, n) =>
  new Date(Date.parse(`${day}T00:00:00Z`) + n * 86400000).toISOString().slice(0, 10);
